export default {
  namespaced: true,
  state: {
    items: [],
    caches: {},
  },
  mutations: {
    add(state, payload) {
      payload = Object.assign({}, payload);

      if (!payload.id) {
        payload = {
          ...payload,
          id: payload.name,
        };
      }
      let index = state.items.findIndex((x) => x.id == payload.id);

      if (index > -1) {
        state.items.splice(index + 1);
        return;
      }

      state.items.push(payload);
    },
    update(state, payload) {
      let route = state.items.find((x) => x.id == payload.id);
      let index = state.items.findIndex((x) => x.id == payload.id);

      if (index == -1) {
        return;
      }

      state.items[index] = {
        ...route,
        ...payload,
      };
    },
    delete(state, payload) {
      let key = payload.id ? payload.id : payload.name;

      let index = state.items.findIndex((x) => x.id == key);
      if (index == -1) {
        return;
      }

      state.items.splice(index, 1);
    },
    slice(state, payload) {
      let key = payload.id ? payload.id : payload.name;

      let index = state.items.findIndex((x) => x.id == key);

      if (index == -1) {
        return;
      }

      state.items.splice(index);
    },
    clear(state) {
      state.items = [];
    },
    cache(state, payload) {
      state.caches[payload.id] = { ...payload.params };
    },
  },
};
